import React, { useState, useEffect, useCallback } from 'react';

const ChatAreaResizeHandle = ({ resizeHandle, modalRef }) => {
    const [showTooltip, setShowTooltip] = useState(false);
    const [isResizing, setIsResizing] = useState(false);
    const [startX, setStartX] = useState(0);
    const [startWidth, setStartWidth] = useState(0);

    const handleMouseEnter = () => {
        setShowTooltip(true);
    };

    const handleMouseLeave = () => {
        setShowTooltip(false);
    };

    const handleMouseDown = useCallback((e) => {
        e.preventDefault();
        setIsResizing(true);
        setStartX(e.clientX);
        setStartWidth(modalRef.current.getBoundingClientRect().width);
    }, [modalRef]);

    const handleMouseMove = useCallback((e) => {
        if (isResizing) {
            const newWidth = startWidth + (e.clientX - startX);
            resizeHandle(newWidth);
        }
    }, [isResizing, startX, startWidth, resizeHandle]);

    const handleMouseUp = useCallback(() => {
        setIsResizing(false);
    }, []);

    useEffect(() => {
        if (isResizing) {
            window.addEventListener('mousemove', handleMouseMove);
            window.addEventListener('mouseup', handleMouseUp);
        } else {
            window.removeEventListener('mousemove', handleMouseMove);
            window.removeEventListener('mouseup', handleMouseUp);
        }

        return () => {
            window.removeEventListener('mousemove', handleMouseMove);
            window.removeEventListener('mouseup', handleMouseUp);
        };
    }, [isResizing, handleMouseMove, handleMouseUp]);

    return (
        <div
            className="dashboard-resize-handle"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            onMouseDown={handleMouseDown}
        >
            {showTooltip && <span className="dashboard-resize-handle-tooltip">チャット欄の幅を変える</span>}
        </div>
    );
};

export default ChatAreaResizeHandle;
